import { useState } from 'react';
import { useSettings, type ThemePref } from '../settings/SettingsContext.js';

// One-time popup shown the first time a user signs in after this update. Announces the new
// look and lets them pick a theme once; changeable later in Settings. No em-dashes in the copy.
const OPTS: { id: ThemePref; label: string; desc: string }[] = [
  { id: 'auto', label: 'Automatic', desc: 'Follows the time of day. Light by day, dark at night.' },
  { id: 'dark', label: 'Dark', desc: 'A sleek, dark corporate look.' },
  { id: 'light', label: 'Light', desc: 'Bright and clean.' },
];

export function FirstRunThemeModal() {
  const { needsThemeChoice, chooseTheme } = useSettings();
  const [sel, setSel] = useState<ThemePref>('auto');
  if (!needsThemeChoice) return null;

  return (
    <div className="modal-bg" style={{ zIndex: 300 }}>
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="first-run-theme-title" style={{ width: 540, maxWidth: '94vw' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-hd"><h3 id="first-run-theme-title">We have updated the UI and UX</h3></div>
        <div className="modal-bd">
          <p className="muted" style={{ marginTop: 0 }}>
            A fresh, sharper interface. Choose how it should look. You can change this any time in Settings.
          </p>
          <div className="theme-choices">
            {OPTS.map((o) => (
              <button
                key={o.id}
                type="button"
                className={`theme-choice ${sel === o.id ? 'sel' : ''}`}
                onClick={() => setSel(o.id)}
                aria-pressed={sel === o.id}
              >
                <span className={`theme-swatch ${o.id}`} aria-hidden="true" />
                <span className="theme-choice-body">
                  <span className="theme-choice-title">
                    {o.label}
                    {o.id === 'auto' && <span className="pill accent" style={{ marginLeft: 6 }}>Recommended</span>}
                  </span>
                  <span className="theme-choice-desc muted">{o.desc}</span>
                </span>
              </button>
            ))}
          </div>
        </div>
        <div className="modal-ft">
          <button className="btn btn-primary" autoFocus onClick={() => chooseTheme(sel)}>Continue</button>
        </div>
      </div>
    </div>
  );
}
